import { createContext, useContext, useReducer } from "react";
import { cartReducer, productReducer } from "./Reducer";


const Cart = createContext();

const Context = ({ children }) => {
  const products = [];

  const [state, dispatch] = useReducer(cartReducer, {
    products: products,
    cart: JSON.parse(localStorage.getItem('cart')) || [],
  });

  const [productState, productDispatch] = useReducer(productReducer, {
    byStock: false,
    byFastDelivery: false,
    byRating: 0,
    searchQuery: "",
  });


  return (
    <Cart.Provider
      value={{
        state,
        dispatch,
        productState,
        productDispatch,
        
      }}
    >
      {children}
    </Cart.Provider>
  );
};

export const CartState = () => {
  return useContext(Cart);
};

export default Context;
